import { createFileRoute } from '@tanstack/react-router';
import { ReviewTab } from '@/features/review/review-tab';

// S02 · Revisione (ADR 0086): what came from Dokless, what Plancia read, what would go to Dokless.
export const Route = createFileRoute('/_app/shipments/$id/review')({
  component: ReviewTab,
});
